'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useCallback, useEffect, useRef, Suspense } from 'react';
import { usePathname } from 'next/navigation';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveHeartLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import HeaderAccountIcon from '@/app/_layout/HeaderAccountIcon';
import { SALE_CATEGORY_ID, DESIGNER_MENU_CATEGORY_ID, BRANDS_MENU_CATEGORY_ID } from '@/app/_lib/config/navigation';
import '@/app/_styles/react-modal-slide-panel.css';

// Category IDs for special menu handling - these get "View All" links in mobile accordion
const BRANDS_CATEGORY_ID = BRANDS_MENU_CATEGORY_ID;
const DESIGNERS_CATEGORY_ID = DESIGNER_MENU_CATEGORY_ID;
const MobileMenu = t0 => {
  const $ = _c(75);
  const {
    menuItems,
    mobileMenuOpen,
    closeMobileMenu
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [openMenuIds, setOpenMenuIds] = useState(t2);
  const [prevPathname, setPrevPathname] = useState(null);
  const prevMobileMenuOpen = useRef(false);
  const menuRef = useRef(null);
  const pathname = usePathname();
  let t3;
  let t4;
  if ($[2] !== closeMobileMenu || $[3] !== pathname || $[4] !== prevPathname) {
    t3 = () => {
      if (prevPathname && prevPathname !== pathname) {
        closeMobileMenu();
        setOpenMenuIds({});
      }
      setPrevPathname(pathname);
    };
    t4 = [pathname, prevPathname, closeMobileMenu];
    $[2] = closeMobileMenu;
    $[3] = pathname;
    $[4] = prevPathname;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] !== mobileMenuOpen) {
    t5 = () => {
      if (mobileMenuOpen && !prevMobileMenuOpen.current) {
        setOpenMenuIds({});
      }
      prevMobileMenuOpen.current = mobileMenuOpen;
    };
    t6 = [mobileMenuOpen];
    $[7] = mobileMenuOpen;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[10] !== mobileMenuOpen) {
    t7 = () => {
      if (mobileMenuOpen) {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
      }
      return _temp2;
    };
    t8 = [mobileMenuOpen];
    $[10] = mobileMenuOpen;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = (level, id) => {
      setOpenMenuIds(prev => ({
        ...prev,
        [level]: prev[level] === id ? null : id
      }));
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const toggleMenu = t9;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e => {
      if (!menuRef.current) {
        return;
      }
      const allFocusable = Array.from(menuRef.current.querySelectorAll("a:not([tabindex=\"-1\"]), button:not([tabindex=\"-1\"])"));
      const visibleFocusable = allFocusable.filter(_temp3);
      const currentIndex = visibleFocusable.indexOf(document.activeElement);
      bb39: switch (e.key) {
        case "ArrowDown":
          {
            e.preventDefault();
            if (currentIndex < visibleFocusable.length - 1) {
              visibleFocusable[currentIndex + 1].focus();
            } else {
              visibleFocusable[0].focus();
            }
            break bb39;
          }
        case "ArrowUp":
          {
            e.preventDefault();
            if (currentIndex > 0) {
              visibleFocusable[currentIndex - 1].focus();
            } else {
              visibleFocusable[visibleFocusable.length - 1].focus();
            }
            break bb39;
          }
        case "Home":
          {
            e.preventDefault();
            visibleFocusable[0]?.focus();
            break bb39;
          }
        case "End":
          {
            e.preventDefault();
            visibleFocusable[visibleFocusable.length - 1]?.focus();
          }
      }
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const handleKeyDown = t10;
  let t11;
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FontAwesomeIcon icon={faHiveHeartLight} aria-hidden="true" className="align-[0px] hover:text-primary text-2xl" />;
    t12 = <span className="pl-2 text-lg">Favorites</span>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== closeMobileMenu) {
    t13 = <Link href="/favorites" title="favorites" className="flex items-center text-light" onClick={closeMobileMenu}>{t11}{t12}</Link>;
    $[17] = closeMobileMenu;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== closeMobileMenu) {
    t14 = <div className="flex items-center text-nowrap text-light"><Suspense><HeaderAccountIcon inMobileNav={true} closeMobileMenu={closeMobileMenu} className="pl-1" /></Suspense></div>;
    $[19] = closeMobileMenu;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13 || $[22] !== t14) {
    t15 = <div className="flex items-center justify-between site-padding py-3 bg-gray-5">{t13}{t14}</div>;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== closeMobileMenu || $[25] !== menuItems || $[26] !== openMenuIds) {
    let t17;
    if ($[28] !== closeMobileMenu || $[29] !== openMenuIds) {
      t17 = menuItem => {
        const hasSubmenu = menuItem.children && menuItem.children.length > 0;
        const isTopLevelOpen = openMenuIds.level1 === menuItem.node_id;
        const isSale = menuItem.category_id === SALE_CATEGORY_ID;
        const menuItemClasses = `flex items-center justify-between w-full site-padding py-1.5 text-xl  text-nowrap hover:text-primary ${isSale ? "text-red" : ""}`;
        return <li key={menuItem.node_id} className="py-1">{hasSubmenu ? <button type="button" onClick={() => toggleMenu("level1", menuItem.node_id)} className={menuItemClasses} aria-expanded={isTopLevelOpen} aria-controls={`submenu-${menuItem.node_id}`}><span>{menuItem.name}</span><FontAwesomeIcon icon={faChevronRight} aria-hidden="true" className={`text-base transition-transform duration-300 ${isTopLevelOpen ? "rotate-90" : ""}`} /></button> : menuItem.url ? <Link href={menuItem.url} className={menuItemClasses} onClick={closeMobileMenu}><span>{menuItem.name}</span></Link> : <span className={menuItemClasses}>{menuItem.name}</span>}{hasSubmenu && <div id={`submenu-${menuItem.node_id}`} className={`grid transition-[grid-template-rows] duration-500 ${isTopLevelOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}><ul className={`list-none min-h-0 overflow-hidden ${isTopLevelOpen ? "opacity-100" : "opacity-0"}`}>{(menuItem.category_id === BRANDS_CATEGORY_ID || menuItem.category_id === DESIGNERS_CATEGORY_ID) && menuItem.url && <li className="py-1"><Link href={menuItem.url} className="block pl-10 pr-6 py-1.5 text-xl hover:text-primary" onClick={closeMobileMenu}>View All {menuItem.name}</Link></li>}{menuItem.children.map(level2 => {
                const isBrandsMenu = menuItem.category_id === BRANDS_CATEGORY_ID;
                const hasLevel3 = !isBrandsMenu && level2.children && level2.children.length > 0;
                const isLevel2Open = openMenuIds.level2 === level2.node_id;
                return <li key={level2.node_id} className="py-1">{hasLevel3 ? <button type="button" onClick={() => toggleMenu("level2", level2.node_id)} className="flex items-center justify-between w-full pl-10 pr-6 py-1.5 text-xl hover:text-primary" aria-expanded={isLevel2Open}><span>{level2.name}</span><FontAwesomeIcon icon={faChevronRight} aria-hidden="true" className={`text-base transition-transform duration-300 ${isLevel2Open ? "rotate-90" : ""}`} /></button> : level2.url ? <Link href={level2.url} className="block pl-10 pr-6 py-1.5 text-xl hover:text-primary" onClick={closeMobileMenu}>{level2.name}</Link> : <span className="block pl-10 pr-6 py-1.5 text-xl">{level2.name}</span>}{hasLevel3 && <div className={`grid transition-[grid-template-rows] duration-500 ${isLevel2Open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}><ul className={`list-none min-h-0 overflow-hidden ${isLevel2Open ? "opacity-100" : "opacity-0"}`}>{level2.children.map(level3 => <li key={level3.node_id} className="py-1">{level3.url ? <Link href={level3.url} className="block pl-14 pr-6 py-1.5 text-xl hover:text-primary" onClick={closeMobileMenu}>{level3.name}</Link> : <span className="block pl-14 pr-6 py-1.5 text-xl">{level3.name}</span>}</li>)}</ul></div>}</li>;
              })}</ul></div>}</li>;
      };
      $[28] = closeMobileMenu;
      $[29] = openMenuIds;
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    t16 = menuItems.filter(_temp4).map(t17);
    $[24] = closeMobileMenu;
    $[25] = menuItems;
    $[26] = openMenuIds;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[31] !== t16) {
    t17 = <ul className="list-none text-left text-dark py-3 border-b border-gray-10">{t16}</ul>;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== closeMobileMenu) {
    t18 = <li className="py-1"><Link href="/about-hive" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>About hive</Link></li>;
    $[33] = closeMobileMenu;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== closeMobileMenu) {
    t19 = <li className="py-1"><Link href="/hive-order-status" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Order Status</Link></li>;
    $[35] = closeMobileMenu;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== closeMobileMenu) {
    t20 = <li className="py-1"><Link href="/hive-trade-program" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Trade Program</Link></li>;
    $[37] = closeMobileMenu;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== closeMobileMenu) {
    t21 = <li className="py-1"><Link href="/favorites" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Favorites</Link></li>;
    $[39] = closeMobileMenu;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== closeMobileMenu) {
    t22 = <li className="py-1"><Link href="/hive-sales-assistance" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Sales Assistance</Link></li>;
    $[41] = closeMobileMenu;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== closeMobileMenu) {
    t23 = <li className="py-1"><Link href="/hive-samples" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Swatch Samples</Link></li>;
    $[43] = closeMobileMenu;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== closeMobileMenu) {
    t24 = <li className="py-1"><Link href="/contact-hive" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Contact</Link></li>;
    $[45] = closeMobileMenu;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== closeMobileMenu) {
    t25 = <li className="py-1"><Link href="/hive-modern-frequently-asked-questions" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>FAQ</Link></li>;
    $[47] = closeMobileMenu;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== closeMobileMenu) {
    t26 = <li className="py-1"><Link href="/hive-modern-store-policy" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Policies</Link></li>;
    $[49] = closeMobileMenu;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== closeMobileMenu) {
    t27 = <li className="py-1"><Link href="/hive-modern-privacy-policy" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Privacy</Link></li>;
    $[51] = closeMobileMenu;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== closeMobileMenu) {
    t28 = <li className="py-1"><Link href="/hive-modern-cookies-policy" className="block site-padding py-2 text-base hover:text-primary" onClick={closeMobileMenu}>Cookie Policy</Link></li>;
    $[53] = closeMobileMenu;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t18 || $[56] !== t19 || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t23 || $[61] !== t24 || $[62] !== t25 || $[63] !== t26 || $[64] !== t27 || $[65] !== t28) {
    t29 = <ul className="list-none text-left text-light py-3">{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}</ul>;
    $[55] = t18;
    $[56] = t19;
    $[57] = t20;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t17 || $[68] !== t29) {
    t30 = <div className="flex items-start flex-col"><nav ref={menuRef} className="w-full" aria-label="Mobile navigation" onKeyDown={handleKeyDown}>{t17}{t29}</nav></div>;
    $[67] = t17;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== closeMobileMenu || $[71] !== mobileMenuOpen || $[72] !== t15 || $[73] !== t30) {
    t31 = <Modal overlayClassName="slide-panel lg:hidden fixed inset-0 outline-none z-40" className={"fixed outline-none bg-white shadow-sm overscroll-contain overflow-y-auto\n inset-0 top-[var(--header-height)] [body.header-collapsed_&]:top-[var(--header-height-collapsed)]"} isOpen={mobileMenuOpen} onRequestClose={closeMobileMenu} contentLabel="Mobile Menu" closeTimeoutMS={500}>{t15}{t30}</Modal>;
    $[70] = closeMobileMenu;
    $[71] = mobileMenuOpen;
    $[72] = t15;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  return t31;
};
export default MobileMenu;
function _temp() {
  Modal.setAppElement("#app");
}
function _temp2() {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}
function _temp3(el) {
  const rect = el.getBoundingClientRect();
  return rect.height > 0 && rect.width > 0;
}
function _temp4(item) {
  return !item.url?.includes("/about-hive");
}